





































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import user from '@/store/modules/user';
import CompanyMixin from '@/mixins/CompanyMixin';

@Component
export default class CardOverview extends CompanyMixin {
    gotoPresentation() {
        if (this.overview) {
            this.openFullscreen();
            this.$router.push({name: 'presentation-quick', params: {OrgNr: this.overview.OrgNr}});
        }
    }

    openFullscreen() {
        const elem: any = document.documentElement;
        if (elem.requestFullscreen) {
        return elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) { /* Firefox */
        return elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        return elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE/Edge */
        return elem.msRequestFullscreen();
        }
    }

    async update() {
        if (this.overview) {
            await user.addCompany(this.overview.OrgNr);
        }
    }

    get pending() {
        return user.fetchingData;
    }

    get hasUpdates() {
        if (!this.overview) { return false; }
        return this.overview.LatestPeriod !== this.overview.CurrentPeriod;
    }
}
